/**
=========================================================
* E4A-Inventory-Tracker - Proprietary Code
* Copyright © 2025 Electronics4All Inc.
=========================================================
 
* This file contains modifications and extensions to the
* Material Dashboard 2 PRO React template by Creative Tim.
* All proprietary features, methods, and implementations
* are the exclusive property of Electronics4All Inc.
 
---------------------------------------------------------
* Material Dashboard 2 PRO React - v2.1.0
* Copyright 2022 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (see LICENSE.md for details)
---------------------------------------------------------
*/

import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Ability } from "@casl/ability";
import App from "App";

// Material Dashboard React Context Provider
import { MaterialUIControllerProvider, AuthContextProvider } from "context";
import { AbilityContext } from "Can";

const container = document.getElementById("root");
const root = createRoot(container);
const ability = new Ability();

root.render(
  <AbilityContext.Provider value={ability}>
    <BrowserRouter>
      <AuthContextProvider>
        <MaterialUIControllerProvider>
          <App ability={ability} />
        </MaterialUIControllerProvider>
      </AuthContextProvider>
    </BrowserRouter>
  </AbilityContext.Provider>
);
